/**
 * Results State Layer
 * Unified state for collection pages; delegates to Tagalys SDK helpers
 */

class ResultsStateLayer {
  constructor () {
    this.passthroughParams = new URLSearchParams(window.location.search)
    this.eventBus = window.theme.tagalys.results.eventBus

    this.state = {
      products: [],
      facets: [],
      activeFacets: [],
      sortOptions: [],
      pagination: {},
      searchParams: '',
    }

    this.subscribeToEvents()
  }

  subscribeToEvents () {
    this.eventBus.subscribe('results:api:fetched:success', response => {
      const requestParams = this.SDK.helpers.getRequestParams()
      const searchParams = this.SDK.helpers.getEncodedQueryString(requestParams)
      const activeFacets = this.SDK.helpers.getAppliedFilters()

      this.products = response.products || []
      this.facets = response.filters || []
      this.activeFacets = activeFacets || []
      this.sortOptions = response.sort_options || []
      this.pagination = {
        page: response.page,
        size: response.per_page,
        total: response.total_count,
      }
      this.searchParams = searchParams

      this.eventBus.publish(
        'results:state:products:updated',
        this.state.products,
      )
      this.eventBus.publish('results:state:facets:updated', this.state.facets)
    })

    this.eventBus.subscribe('results:ui:facet:added', ({ field, value }) => {
      this.SDK.helpers.applyFilter(field, value)
    })

    this.eventBus.subscribe('results:ui:facet:removed', ({ field, value }) => {
      this.SDK.helpers.clearFilter(field, value)
    })

    this.eventBus.subscribe('results:ui:facet:clearAll', () => {
      this.SDK.helpers.clearAllFilters()
      const passthroughString = this.passthroughParams.toString()
      window.history.replaceState(
        {},
        '',
        window.location.origin +
          window.location.pathname +
          (passthroughString ? `?${passthroughString}` : ''),
      )
    })

    this.eventBus.subscribe('results:ui:pagination:changed', cursor => {
      this.SDK.helpers.goToPage(parseInt(cursor.page, 10))
    })
  }

  get SDK () {
    return window.theme.tagalys.results.SDK
  }

  get facets () {
    return this.state.facets
  }

  get products () {
    return this.state.products
  }

  set products (products) {
    this.state.products = products
  }

  set facets (facets) {
    this.state.facets = this.filterZeroCountItems(facets)
  }

  filterZeroCountItems (facets) {
    return facets.map(facet => {
      if (facet.items) {
        return {
          ...facet,
          items: facet.items.filter(item => item.count > 0 || item.selected),
        }
      }
      return facet
    })
  }

  get searchParams () {
    return this.state.searchParams
  }

  set searchParams (searchParams) {
    if (searchParams === this.state.searchParams) return
    const merged = new URLSearchParams(this.passthroughParams.toString())
    new URLSearchParams(searchParams).forEach((value, key) => {
      if (key === 'q') return
      merged.set(key, value)
    })
    ;['filter.v.option.size', 'filter.v.availability', 'sort_by'].forEach(
      key => {
        merged.delete(key)
      },
    )
    try {
      const query = merged.toString()
      window.history.replaceState(
        {},
        '',
        `${window.location.origin}${window.location.pathname}${
          query ? `?${query}` : ''
        }`,
      )
    } catch (e) {
      // Browser throttles history API on rapid successive calls
    }
    this.state.searchParams = searchParams
  }

  get sortOptions () {
    return this.state.sortOptions
  }

  set sortOptions (sortOptions) {
    this.state.sortOptions = sortOptions
  }

  get activeFacets () {
    return this.state.activeFacets
  }

  set activeFacets (activeFacets) {
    this.state.activeFacets = activeFacets
  }

  get pagination () {
    return this.state.pagination
  }

  set pagination (pagination) {
    this.state.pagination = pagination
  }
}

window.theme.tagalys.results.stateLayer = new ResultsStateLayer()
